module.exports = __webpack_public_path__ + "img/2.2bc515a9.png";